import React from 'react';

const AdminFooter = () => (
  <footer className="admin-footer">
    <span>© {new Date().getFullYear()} Wedding Admin</span>
    <span>Console d’administration v1.0</span>
  </footer>
);

export default AdminFooter;
